export const applicationName = "Pickle Tracker";
export const applicationDescription = "Pickle Tracker is used to track pickleball scores.";
export const applicationDetails = (
    <>
        This watch application is used easily to track pickleball matches during the game to help keep track of the score and what is the current service.
        <br />
        <ul>
        <li>To use the app, start the application on the watch.</li>
        <li>To start a match width the opposing team, press the red reset button.</li>
        <li>To start a match with your team, press the green reset button.</li>
        <li>To score a point for the opposing team, press the red point button.</li>
        <li>To score a point for your team, press the green point button.</li>
        <li>Press one of the corner buttons to set the server.</li>
        <li>The server call is the text in the middle.</li>
        </ul>
    </>
);
export const showAppleWatchScreenshot = true
export const appleWatchScreenshotWidth = 416 * (360 / 496);
export const appleWatchScreenshotHeight = 496 * (360 / 496);
export const showZeppOSScreenshot = true
export const zeppOSScreenshotWidth = 360;
export const zeppOSScreenshotHeight = 360;

export const deploymentWebLocation = "/app/pickletrack";

export const versionLocation = "pickletrack/version.json";

export const enum PlatformLocation {
    DoNotShow,
    AppStore,
}

export const showAppleWatchInfo: PlatformLocation = PlatformLocation.DoNotShow;
export const appleWatchAppStoreLocation = "https://apps.apple.com/us/app/feature-logging/id6480532610";
export const appleWatchReleaseNotesLocation = "releaseNotes-apple-watch.json";

export const showZeppOSInfo: PlatformLocation = PlatformLocation.DoNotShow;
export const zeppOSAppStoreLocation = "https://apps.apple.com/us/app/feature-logging-pad/id6740720721";
export const zeppOSReleaseNotesLocation = "releaseNotes-zeppos.json";

export const supportEmail = "andydragon@live.com";

export const hasTutorial = false;

export type Platform = "appleWatch" | "zeppOS";

export const platformString: Record<Platform, string> = {
    appleWatch: "Apple Watch",
    zeppOS: "Zepp OS",
}

export interface Links {
    readonly useAppStore?: true;
    readonly location: (version: string, flavorSuffix: string) => string;
    readonly actions: {
        readonly action: string;
        readonly target: string;
        readonly suffix: string;
    }[];
}

export const links: Record<Platform, Links | undefined> = {
    appleWatch: {
        useAppStore: true,
        location: (_version, _suffix) => appleWatchAppStoreLocation,
        actions: [
            {
                action: "install from Apple app store",
                target: "_blank",
                suffix: "",
            }
        ]
    },
    zeppOS: {
        useAppStore: true,
        location: (_version, _suffix) => zeppOSAppStoreLocation,
        actions: [
            {
                action: "install from Zepp OS app store",
                target: "_blank",
                suffix: "",
            }
        ]
    },
};
